<template>
    <div>

        <b-modal id="detail" size="lg" title="Hesaplama Geçmişi" body-class="p-50" no-close-on-esc no-close-on-backdrop hide-footer>
            <calculate-salary-process-levy-lock-detail :detail="detail"></calculate-salary-process-levy-lock-detail>
        </b-modal>

        <b-modal id="edit" size="lg" title="Ödenecek İcra Tutarı Düzenleme" body-class="p-50" no-close-on-esc no-close-on-backdrop>
            <calculate-salary-process-levy-edit v-model="editData" :salary-payment-date="rSalaryPaymentDate" :filter="filter"></calculate-salary-process-levy-edit>
            <template #modal-footer><v-executer :loading="interventing" text="Gönder" :action="edit"></v-executer></template>
        </b-modal>

        <b-card no-body class="mb-1">
            <b-overlay :show="getting" opacity="0.2">
                <div class="p-1">
                    <div class="row">
                        <div class="col-md-3 mb-1 mb-md-0">             
                            <b-input-group class="input-group-merge">
                                <template #prepend>
                                    <b-input-group-text >
                                        <feather-icon icon="SearchIcon"></feather-icon>
                                    </b-input-group-text>
                                </template>
                                <b-form-input placeholder="Ara..." v-on:keyup.enter="getData" v-model="searchValue"></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-date-picker :disabled="getting" :value="salaryPaymentDate" placeholder="Tarih" v-on:change="$e => $emit('salary-payment-date',$e)"></v-date-picker>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0">
                            <button class="btn btn-success btn-block" v-on:click="getData">
                                Sorgula
                            </button>
                        </div>
                        <div class="col-md-auto mb-1 mb-md-0 ml-auto">
                            <b-dropdown :disabled="acting" text="İşlemler" right :variant="'primary'">
                                <template #button-content>
                                    <b-spinner v-if="acting" small/>
                                    <template v-else>İşlemler</template>
                                </template>
                                <b-dropdown-item v-on:click="approve">
                                    <feather-icon icon="CheckCircleIcon" class="mr-50"></feather-icon>
                                    Tüm İcraları Onayla
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <template v-if="tableResult == null">
                    <div class="table-responsive">
                        <table class="table table-sm bordered-header">
                            <thead>
                                <tr>
                                    <th class="text-nowrap w-20 py-05">Sicil Numarası</th>
                                    <th class="text-nowrap w-20 py-05">Personel</th>
                                    <th class="text-nowrap w-20 py-05">Kimlik Numarası</th>
                                    <th class="text-nowrap w-10 py-05">Org. Şube</th>
                                    <th class="text-nowrap w-10 py-05">SGK Şube</th>
                                    <th class="text-nowrap w-20 py-05 text-right">Tutar (TL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(p,i) in (datas || [])">
                                    <tr :key="i">
                                        <td class="text-nowrap">{{ $safe(p,'SICIL_NO') }}</td>
                                        <td class="text-nowrap">{{ $safe(p,'FullName') }}</td>
                                        <td class="text-nowrap">{{ $safe(p,'IdentityNumber') }}</td>
                                        <td class="p-0 border-left">
                                            <table class="table table-sm">
                                                <tr v-for="(dd,ii) in p.Datas">
                                                    <td :class="{'border-0':ii==0}">{{ $safe(dd,'OBranchName') || '-' }}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td class="p-0 border-right">
                                            <table class="table table-sm">
                                                <tr v-for="(dd,ii) in p.Datas">
                                                    <td :class="{'border-0':ii==0}">{{ $safe(dd,'SGKBranchName') || '-' }}</td>
                                                </tr>
                                            </table>
                                        </td>
                                        <td class="p-0">
                                            <table class="table table-sm">
                                                <tr v-for="(dd,ii) in p.Datas">
                                                    <td :class="[{'border-0':ii==0,'text-danger':hasError(dd)},'text-right']">
                                                        <div class="d-flex g-25 align-items-center justify-content-between">
                                                            <div class="d-flex g-25 align-items-center ml-auto">
                                                                <button class="btn btn-xxs btn-flat-info btn-icon" v-b-tooltip.noninteractive.bottom.hover="'Hesaplama Geçmişi'" v-on:click="showDetail(dd)">
                                                                    <feather-icon icon="InfoIcon"></feather-icon>
                                                                </button>
                                                                <button v-if="rSalaryPaymentDate && dd.LastAmount != null" class="btn btn-xs btn-flat-secondary btn-icon" :disabled="interventing" v-b-tooltip.noninteractive.bottom.hover="'Ödenecek İcra Tutarı Düzenleme'" v-on:click="showEdit(p,dd)">
                                                                    <feather-icon icon="Edit2Icon"></feather-icon>
                                                                </button>
                                                            </div>
                                                            <template v-if="$safe(dd,'LastAmountStr')">
                                                                {{ $safe(dd,'LastAmountStr') || '-' }}
                                                            </template>
                                                            <b-badge v-else variant="light-danger">İcra hesaplama süreci henüz tamamlanmamış.</b-badge>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>                               
                                        </td>
                                    </tr>
                                </template>
                                <tr v-if="(datas || []).length == 0">
                                    <td colspan="100" class="text-center">Henüz bir veri bulunmamaktadır.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mx-75 my-1" v-if="total!='0'">
                        <div class="bg-light border rounded">
                            <div class="d-flex align-items-center p-50">
                                <div class="row justify-content-md-between justify-content-center text-success">
                                    <div class="col-auto mb-1 mb-md-0">
                                        <div class="d-flex align-items-center g-50">
                                            <span class="material-icons-outlined" >calculate</span>
                                            <b>TOPLAM: {{total || 0}}</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mx-75 mb-1" v-if="count > 0">
                        <div class="row justify-content-md-between justify-content-center">
                            <div class="col-auto mb-1 mb-md-0">
                                <div class="d-flex align-items-center text-nowrap">
                                    Toplam {{(count || 0)}} kayıt arasından
                                    <select class="form-control form-control-sm mx-50 per-page-select" v-model="perPage">
                                        <option v-for="pp in perPages" :key="pp" :value="pp">{{pp}}</option>
                                    </select>
                                    gösteriliyor.   
                                </div>
                            </div>
                            <div class="col-auto mb-1 mb-md-0">
                                <b-pagination class="mb-0" v-model="page" :total-rows="((count || 0))" :per-page="perPage"></b-pagination>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger mb-1 mx-1">
                        <div class="alert-body">
                            {{ $safe(tableResult,'Message') }}
                        </div>
                    </div>
                </template>
            </b-overlay>
        </b-card>
        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
                <div class="col-auto">
                    <button class="btn btn-sm btn-secondary" v-on:click="$emit('next')">İleri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations';
import { BPagination, BOverlay, BInputGroup, BInputGroupText, BFormInput, BSpinner,VBTooltip, BCard, BDropdown, BDropdownItem, BBadge } from 'bootstrap-vue'
import CalculateSalaryProcessBesRobot from './bes/CalculateSalaryProcessBesRobot.vue'
import CalculateSalaryProcessLevyLockDetail from './CalculateSalaryProcessLevyLockDetail.vue';
import CalculateSalaryProcessLevyEdit from './CalculateSalaryProcessLevyEdit.vue';

export default{
    components:{
        BPagination,
        BOverlay,
        BInputGroup,
        BInputGroupText,
        BFormInput,
        CalculateSalaryProcessBesRobot,
        CalculateSalaryProcessLevyLockDetail,
        CalculateSalaryProcessLevyEdit,
        BSpinner,
        BCard,
        BDropdown, 
        BDropdownItem, 
        BSpinner,
        BBadge
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    props:{
        donem:{
            type:Object,
            default:()=>({
                year:null,
                month:null
            })
        },
        filter:{
            type:Object,
            default:() => ({})
        },
        salaryPaymentDate:{
            type:String,
            default:null
        }
    },
    watch:{
        "page"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        },
        "perPage"(oldV,newV){
            if(oldV && newV && oldV != newV){
                this.getData()
            }
        }
    },
    data(){
        return {
            page:1,
            perPage:10,
            perPages:[10,20,30,40,50,100],
            years:[],
            months:[
                {index:1,name:'Ocak'},
                {index:2,name:'Şubat'},
                {index:3,name:'Mart'},
                {index:4,name:'Nisan'},
                {index:5,name:'Mayıs'},
                {index:6,name:'Haziran'},
                {index:7,name:'Temmuz'},
                {index:8,name:'Ağustos'},
                {index:9,name:'Eylül'},
                {index:10,name:'Ekim'},
                {index:11,name:'Kasım'},
                {index:12,name:'Aralık'}
            ],
            datas:[],
            count:0,
            total:0,
            getting: false,
            searchOnTableTimer:null,
            searchValue:"",
            acting:false,
            tableResult:null,
            detail:null,
            rSalaryPaymentDate:null,
            editData:{
                EmployeeId:null,
                FullName:null,
                Amount:null,
                Description:null,
                TIP:3,
                SIRA_NO: 2,
                Month:null,
                Year:null,
                AdditionalLevyPayments:[],
                SGKJobNoticeId:null,
                CalculatedAmount:null,
                SGKJobNoticeId:null,
            },
            interventing:false
        }
    },
    methods:{
        clearForm(){
            this.editData.EmployeeId = null
            this.editData.FullName = null
            this.editData.Amount = null
            this.editData.Description = null
            this.editData.Month = null
            this.editData.Year = null
            this.editData.AdditionalLevyPayments = []
            this.editData.CalculatedAmount = null
        },
        getData(){
            this.getting = true
            this.rSalaryPaymentDate = null
            EmployeeOperationsApi.EmployeeExceptionalKYKMCalculationStatusTable({
                SalaryFilter:{
                    ...this.filter,
                    Month:this.donem.month,
                    Year:this.donem.year,
                    SalaryPaymentDate:this.salaryPaymentDate,
                    PaginateRequest:{
                        IsAscending:true,
                        OrderColumnName:'FullName',
                        QueryParam:this.searchValue,
                        Skip:this.page,
                        Take:this.perPage
                    }
                },
                SIRA_NO:2,
                TIP:3,
                Approval:true
            }).then(res=> {
                if(res.data.Success){
                    this.rSalaryPaymentDate = this.salaryPaymentDate,
                    this.tableResult = null
                    this.datas = res.data.Data.Data || []
                    this.count = res.data.Data.TotalCount || 0
                    this.total = res.data.Data.TotalAmountStr || "0"
                }else{
                    this.tableResult = res.data
                }
                this.getting = false
            }).catch(err => {
                this.getting = false
            })
        },
        showDetail(d){
            this.detail = null
            this.detail = d
            this.$showModal('detail')
        },
        showEdit(d,pp){
            this.clearForm()
            this.editData.EmployeeId = d.EmployeeId
            this.editData.FullName = d.FullName
            this.editData.Month = this.donem.month
            this.editData.Year = this.donem.year
            this.editData.CalculatedAmount = pp.OriginalAmount
            this.editData.SGKJobNoticeId = pp.SGKJobNoticeId
            this.$showModal('edit')
        },
        edit(){
            this.interventing = true
            EmployeeOperationsApi.EmployeeExceptionalKYKMIntervent(this.editData).then(res => {
                if(res.data.Success){
                    this.getData()
                    this.$hideModal('edit')
                }
                this.$result(res)
                this.interventing = false
            }).catch(err => {
                this.$result(null,err)
                this.interventing = false
            })
        },
        approve(){
            this.acting = true
            EmployeeOperationsApi.EmployeeExceptionalKYKMApprove({
                SalaryFilter:{
                    ...this.filter,
                    Month:this.donem.month,
                    Year:this.donem.year,
                    SalaryPaymentDate:this.salaryPaymentDate,
                    PaginateRequest:{
                        IsAscending:true,
                        OrderColumnName:'FullName',
                        QueryParam:this.searchValue,
                        Skip:this.page,
                        Take:this.perPage
                    }
                },
                SIRA_NO:2,
                TIP:3,
            }).then(res => {
                this.$result(res)
                this.acting = false
                this.getData()
            }).catch(err => {
                this.$result(null,err)
                this.acting = false
            })
        },
        hasError(d){
            return (d.Results || []).toSorted((a, b) => {
                const dateA = moment(a.CalculationDateTimeStr,'DD.MM.YYYY hh:mm')
                const dateB = moment(b.CalculationDateTimeStr,'DD.MM.YYYY hh:mm')
                return dateB.diff(dateA)
            })[0]?.Errors?.length > 0 || false
        }
    }
}
</script>